import type { ReactNode } from 'react';

interface SidebarSectionProps {
    label: string;
    count?: number;
    /** Labels a form control (the sort select) instead of a group. */
    htmlFor?: string;
    children: ReactNode;
}

// Same label treatment as PracticeFilterList, so every sidebar section reads as one list.
export function SidebarSection({ label, count = 0, htmlFor, children }: SidebarSectionProps) {
    const labelClassName = 'text-[11px] font-medium text-gray-400 uppercase tracking-wider';
    const text = (
        <>
            {label}
            {count > 0 && <> &middot; {count}</>}
        </>
    );
    return (
        <div className="flex flex-col gap-2">
            {htmlFor ? (
                <label htmlFor={htmlFor} className={labelClassName}>
                    {text}
                </label>
            ) : (
                <span className={labelClassName}>{text}</span>
            )}
            {children}
        </div>
    );
}
